<div class="content-card">
  <div fxLayout="row" fxLayoutAlign="space-between center">
    <h2>{{ 'WALL-LeaveLimitsForTheCurrentYear' | translate }}</h2>
  </div>
  <div class="table-wrapper">
    @if (absenceLimits().length) {
    <table class="table">
      <thead>
        <tr class="table__head-row">
          <th rowspan="2" class="table__head-cell table__head-cell--strong">{{ 'AbsenceType' | translate }}</th>
          <th colspan="2" class="table__head-cell table__head-cell--strong">{{ 'WALL-AmountDue' | translate }}</th>
          <th colspan="2" class="table__head-cell table__head-cell--strong">{{ 'WALL-AmountUsed' | translate }}</th>
          <th colspan="2" class="table__head-cell table__head-cell--strong">{{ 'WALL-AmountLeft' | translate }}</th>
        </tr>
        <tr class="table__head-row">
          <th class="table__head-cell">{{ 'WALL-DailyLeave' | translate }}</th>
          <th class="table__head-cell">{{ 'WALL-HourlyLeave' | translate }}</th>
          <th class="table__head-cell">{{ 'WALL-DailyLeave' | translate }}</th>
          <th class="table__head-cell">{{ 'WALL-HourlyLeave' | translate }}</th>
          <th class="table__head-cell">{{ 'WALL-DailyLeave' | translate }}</th>
          <th class="table__head-cell">{{ 'WALL-HourlyLeave' | translate }}</th>
        </tr>
      </thead>
      <tbody>
        @if(absenceTypesMap()[AbsenceLimitType.Vacation]; as absence) {
        <tr class="table-row table-row--strong">
          <td>{{ 'WALL-Leave' | translate }}</td>
          <td>{{ absence.due.days }}</td>
          <td>{{ absence.due.hours }}</td>
          <td>{{ absence.dueUsed.days }}</td>
          <td>{{ absence.dueUsed.hours }}</td>
          <td>{{ absence.dueLeft.days }}</td>
          <td>{{ absence.dueLeft.hours }}</td>
        </tr>
        }
        @if(absenceTypesMap()[AbsenceLimitType.Vacation]; as absence) {
        <tr class="table-row">
          <td>{{ 'WALL-LeaveOverdue' | translate }}</td>
          <td>{{ absence.overdue.days }}</td>
          <td>{{ absence.overdue.hours }}</td>
          <td>{{ absence.overdueUsed.days }}</td>
          <td>{{ absence.overdueUsed.hours }}</td>
          <td>{{ absence.overdueLeft.days }}</td>
          <td>{{ absence.overdueLeft.hours }}</td>
        </tr>
        }
        @if(absenceTypesMap()[AbsenceLimitType.Vacation]; as absence) {
        <tr class="table-row">
          <td>{{ 'WALL-LeaveDue' | translate }}</td>
          <td>{{ absence.current.days }}</td>
          <td>{{ absence.current.hours }}</td>
          <td>{{ absence.currentUsed.days }}</td>
          <td>{{ absence.currentUsed.hours }}</td>
          <td>{{ absence.currentLeft.days }}</td>
          <td>{{ absence.currentLeft.hours }}</td>
        </tr>
        }
        @if(absenceTypesMap()[AbsenceLimitType.OnDemand]; as absence) {
        <tr class="table-row">
          <td>{{ 'WALL-LeaveOnDemand' | translate }}</td>
          <td>{{ absence.due.days }}</td>
          <td>-</td>
          <td>{{ absence.dueUsed.days }}</td>
          <td>-</td>
          <td>{{ absence.dueLeft.days }}</td>
          <td>-</td>
        </tr>
        }
        @if(absenceTypesMap()[AbsenceLimitType.ChildCare]; as absence) {
        <tr class="table-row table-row--strong">
          <td>{{ 'WALL-ChildCareLeave' | translate }}</td>
          <td>{{ absence.due.daysOrDash }}</td>
          <td>{{ absence.due.hoursOrDash }}</td>
          <td>{{ absence.dueUsed.daysOrDash }}</td>
          <td>{{ absence.dueUsed.hoursOrDash }}</td>
          <td>{{ absence.dueLeft.daysOrDash }}</td>
          <td>{{ absence.dueLeft.hoursOrDash }}</td>
        </tr>
        }
        @if(absenceTypesMap()[AbsenceLimitType.DayOffApplication]; as absence) {
        <tr class="table-row table-row--strong">
          <td>{{ 'WALL-DayOffApplication' | translate }}</td>
          <td>{{ absence.due.daysOrDash }}</td>
          <td>{{ absence.due.hoursOrDash }}</td>
          <td>{{ absence.dueUsed.daysOrDash }}</td>
          <td>{{ absence.dueUsed.hoursOrDash }}</td>
          <td>{{ absence.dueLeft.daysOrDash }}</td>
          <td>{{ absence.dueLeft.hoursOrDash }}</td>
        </tr>
        }
        @if(absenceTypesMap()[AbsenceLimitType.JobSearchLeave]; as absence) {
        <tr class="table-row">
          <td>{{ 'WALL-JobSearchLeave' | translate }}</td>
          <td>{{ absence.due.days }}</td>
          <td>{{ absence.due.hoursOrDash }}</td>
          <td>{{ absence.dueUsed.daysOrDash }}</td>
          <td>{{ absence.dueUsed.hoursOrDash }}</td>
          <td>{{ absence.dueLeft.daysOrDash }}</td>
          <td>{{ absence.dueLeft.hoursOrDash }}</td>
        </tr>
        }
        @if(absenceTypesMap()[AbsenceLimitType.UnpaidCareLeave]; as absence) {
        <tr class="table-row">
          <td>{{ 'WALL-UnpaidLeaveCare' | translate }}</td>
          <td>{{ absence.due.daysOrDash }}</td>
          <td>{{ absence.due.hoursOrDash }}</td>
          <td>{{ absence.dueUsed.daysOrDash }}</td>
          <td>{{ absence.dueUsed.hoursOrDash }}</td>
          <td>{{ absence.dueLeft.daysOrDash }}</td>
          <td>{{ absence.dueLeft.hoursOrDash }}</td>
        </tr>
        }
        @if(absenceTypesMap()[AbsenceLimitType.ForceMajeureLeave]; as absence) {
        <tr class="table-row">
          <td>{{ 'WALL-ForceMajeureLeave' | translate }}</td>
          <td>{{ absence.due.daysOrDash }}</td>
          <td>{{ absence.due.hoursOrDash }}</td>
          <td>{{ absence.dueUsed.daysOrDash }}</td>
          <td>{{ absence.dueUsed.hoursOrDash }}</td>
          <td>{{ absence.dueLeft.daysOrDash }}</td>
          <td>{{ absence.dueLeft.hoursOrDash }}</td>
        </tr>
        }
      </tbody>
    </table>
    }
  </div>
</div>